<div class="search-bar-container">
    <mat-form-field>
        <mat-label>Rechercher</mat-label>
        <input type="text" matInput [formControl]="formControl">
    </mat-form-field>
</div>